import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SelectInput from "../../SelectInput/index";
import { listConfig } from '@/api/configurationlist';
export default {
  props: ["deviceDid", "deviceSn", 'IpList'],
  components: {
    SelectInput: SelectInput
  },
  data: function data() {
    return {
      redirect: [{
        index: '',
        options: {
          dest_port: '',
          enabled: false,
          dest_ip: '',
          dest: 'lan',
          src_dport: '',
          src: 'wan',
          proto: 'tcp udp',
          name: ''
        },
        action: 1,
        sname: ''
      }],
      protocolList: [{
        value: 'tcp udp',
        label: 'TCP+UDP'
      }, {
        value: 'tcp',
        label: 'TCP'
      }, {
        value: 'udp',
        label: 'UDP'
      }, {
        value: 'other',
        label: this.$t('lang.port.other')
      }],
      wanList: [{
        value: 'wan',
        label: 'wan'
      }],
      lanList: [{
        value: 'lan',
        label: 'lan'
      }],
      destInputShow: false
    };
  },
  methods: {
    clearData: function clearData() {
      this.redirect = [{
        index: '',
        options: {
          dest_port: '',
          enabled: false,
          dest_ip: '',
          dest: 'lan',
          src_dport: '',
          src: 'wan',
          proto: 'tcp udp',
          name: ''
        },
        action: 1,
        sname: ''
      }];
    },
    //修改内部Ip地址
    Dest_ipSelectInput: function Dest_ipSelectInput(props, index) {
      this.redirect[0].options.dest_ip = props;
    },
    addRedirect: function addRedirect(row) {
      var _this = this;

      var data = this.redirect[0].options;

      if (data.dest_port == '' || data.src_dport == '' || data.name == '') {
        this.$confirm(this.$t('lang.port.addTips'), this.$t('lang.port.tips'), {
          confirmButtonText: this.$t('lang.Button.submit'),
          cancelButtonText: this.$t('lang.Button.cancel')
        }).then(function () {
          _this.$emit('addRedirect', _this.redirect[0]);

          _this.clearData();
        }).catch(function () {});
      } else {
        this.$emit('addRedirect', this.redirect[0]);
        this.clearData();
      }
    },
    // 监听选择下拉框的变化
    destChange: function destChange(val, index) {
      var _this2 = this;

      if (val === '自定义') {
        this.redirect[index].options.dest_ip = '';
        this.destInputShow = true;
        this.$nextTick(function () {
          _this2.$refs.dest.focus();
        });
      }
    },
    destBlur: function destBlur() {
      this.destInputShow = false;
    }
  }
};